<template>
    <print-layout>
        <div v-for="(steps, page_index) in pages" :key="page_index" class="">
            <!-- Header -->
            <div class="m-4 mt-2 relative">
                <div class="flex gap-x-12 items-center">
                    <img
                        src="/images/logo.png"
                        class="h-20"
                    />

                    <div>
                        <div class="text-4xl font-bold pt-8">{{ sop.title }}</div>
                        <div class="flex gap-x-4">
                            <div v-if="sop.creator" class="text-gray-600 text-xs">
                                Created {{ formatTimestamp(sop.created_at) }} by {{ sop.creator.name }}
                            </div>
                            <div v-if="sop.updater" class="text-gray-600 text-xs">
                                Updated {{ formatTimestamp(sop.updated_at) }} by {{ sop.updater.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-0 right-0">
                    <div class="font-bold">Page {{ page_index + 1}}</div>
                </div>
            </div>

            <!-- Steps -->
            <div class="grid grid-cols-4 gap-2 px-4">
                <div v-for="(step, index) in steps" :key="step.id">
                    <div class="relative">
                        <div v-if="step.uploads.length" class="flex justify-center h-44 max-h-44 relative rounded-xl overflow-hidden border border-gray-200">
                            <img 
                                :src="`/storage/${step.uploads[0].path}`" 
                                class="object-contain"
                            />
                        </div>
                        
                        <div
                            class="inline-block border rounded-full bg-white py-1 px-2 text-lg leading-none font-bold"
                            :class="{'absolute top-2 left-2': step.uploads.length}"
                        >
                            {{ Number(index) + 1 }}
                        </div>
                    </div>
                    
                    <div
                        :class="{
                            'max-h-44': step.uploads.length,
                        }"
                        :style="{
                            'max-height': !step.uploads.length ? '23.5rem' : null
                        }"
                        class="normal-lists description-fit"
                        v-html="step.description"
                    />
                </div>
            </div>

            <div v-if="page_index < pages.length" class="page-break"></div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';
import textFit from 'textfit'

export default {
    setup() {

    },

    components: {
        PrintLayout,
    },

    props: [
        'sop',
        'pages'
    ],

    methods: {
        applyTextFit() {
            this.$nextTick(() => {
                const elements = document.querySelectorAll('.description-fit')
                if (elements?.length) {
                    textFit(elements, {
                        multiLine: true,
                        alignVert: false,
                        maxFontSize: 20,
                        minFontSize: 8
                    })
                }
            })
        }
    },

    mounted() {
        this.applyTextFit();
    },
}
</script>

<style scoped>
    .page-break {
        page-break-after: always;
    }
</style>
